import * as staffApi from '../../api/staffApi'
import * as announcementApi from "../../api/announcementApi";

const state = {
  List: [],
  HasMore: true,
  PageIndex: 1
}

const getters = {

}

const actions = {
  async GetStaffByMerchantId({ commit }, requestObj) {
    if (state.HasMore) {
      const response = await staffApi.GetMerchantStaffList(requestObj)
      if (response.Status) {
        if (response.PageNo >= response.PageCount) {
          commit('setHasMore', false)
        } else {
          commit('setPageIndex', response.PageNo + 1)
        }
        commit('setStaffList', response.Rows)
      }
    }
  },
  async GetStaffByStoreId({ commit }, requestObj) {
    if (state.HasMore) {
      const response = await staffApi.GetStoreStaffList(requestObj)
      if (response.Status) {
        if (response.PageNo >= response.PageCount) {
          commit('setHasMore', false)
        } else {
          commit('setPageIndex', response.PageNo + 1)
        }
        commit('setStaffList', response.Rows)
      }
    }
  },
  EmptyState({commit}){
    commit('emptyState')
  },
	async GetRepaireListByShopNo({commit},storeId){
		const response =await staffApi.GetRepaireListByShopNo(storeId);
		return response
	},
}

const mutations = {
  setStaffList(state, list) {
    let tempList = state.List
    tempList = tempList.concat(list)
    state.List = tempList
  },
  setHasMore(state, hasMore) {
    state.HasMore = hasMore
  },
  setPageIndex(state, pageIndex) {
    state.PageIndex = pageIndex
  },
  emptyState(state){
    state.List = [];
    state.HasMore = true;
    state.PageIndex = 1;
  },
}

export default {
  namespaced: true,
  getters,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/staff-list.js